import React from 'react';
import styled from 'styled-components';

const OnOffButtonSt = {
  Wrap: styled.button`
    position: relative;
    width: 72px;
    height: 36px;
    box-sizing: border-box;
    border-radius: 50px;
    border: 1px solid #48484847;
    transition: 0.4s;
    &:before {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: #fff;
      transition: 0.4s;
      content: '';
      width: 28px;
      height: 28px;
      border-radius: 50%;
      box-shadow: 0 0 5px 0 #00000040;
    }
    &.on {
      background: #4ea6d2;
      border: 1px solid #48484847;
      > span {
        &:last-child {
          opacity: 1;
        }
      }
      &:before {
        left: 4px;
      }
    }
    &.off {
      background: #e5e8ec;
      border: 1px solid #d4d8df;
      > span {
        &:first-child {
          opacity: 1;
        }
      }
      &:before {
        left: calc(100% - 28px - 4px);
      }
    }
  `,
  Text: styled.span`
    position: absolute;
    opacity: 0;
    font-size: 14px;
    letter-spacing: -1px;
    font-weight: 600;
    top: 50%;
    transform: translateY(-50%);
    transition: 0.4s;
    &:first-child {
      color: #9eabb6;
      left: 8px;
    }
    &:last-child {
      color: #fff;
      right: 12px;
    }
  `,
};

interface OnOffButtonProps {
  onClick: () => void;
  active: boolean;
}

const OnOffButton = ({ onClick, active }: OnOffButtonProps) => {
  return (
    <OnOffButtonSt.Wrap onClick={onClick} className={active ? 'on' : 'off'}>
      <OnOffButtonSt.Text>OFF</OnOffButtonSt.Text>
      <OnOffButtonSt.Text>ON</OnOffButtonSt.Text>
    </OnOffButtonSt.Wrap>
  );
};

export default OnOffButton;
